import { ECoworkingAccess, IJsonQuery } from '../json_query';

export function getCoworkingAccessFromJsonQuery(jsonQuery: IJsonQuery): ECoworkingAccess[] {
  const allDayValue = jsonQuery.all_day_access?.value ? ECoworkingAccess.AllDay : null;
  const allWeekValue = jsonQuery.all_week_access?.value ? ECoworkingAccess.AllWeek : null;

  return [allDayValue, allWeekValue].filter(Boolean) as ECoworkingAccess[];
}
